export default __webpack_public_path__ + "static/media/webkit.e42a380e.svg";